// extracted by mini-css-extract-plugin
export default {"container":"oz9MUl","title":"Xjk1MY","postsList":"ATfZ5f","postListItem":"dMS8iW"};